class ScrollingText extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const tickerWidth = window.BAO.MediaBreakpoints.isSm
      ? this.els.items.element.offsetWidth / 100
      : this.els.items.element.offsetWidth / 60

    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('scrolling-text')) {
  customElements.define('scrolling-text', ScrollingText)
}
